<div class="container">
  <div class="close-button">
    <button mat-icon-button (click)="closeModal()"><mat-icon>close</mat-icon></button>
  </div>
  <div class="content">
    <div class="success-confirm" *ngIf="data.type === 'successConfirmation'">
      <h1>{{ data.title }}</h1>
      <mat-dialog-actions align="end">
        <button mat-button (click)="closeModal()">OK</button>
      </mat-dialog-actions>
    </div>
    <div class="exit-confirmation" *ngIf="data.type === 'exitConfirmation'">
      <h1>{{ 'Shared.ChangesWereNotSaved' | translate }}</h1>
      <p [innerHTML]="'Shared.ChangesWereNotSavedInfo' | translate"></p>
      <mat-dialog-actions>
        <div class="buttons deletion-buttons">
          <button mat-button (click)="closeModal()" class="default-button">
            {{ 'Shared.Cancel' | translate }}
          </button>
          <button mat-button (click)="closeAllModals()" class="red-default-button">
            {{ 'Shared.BacktoHome' | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
    <div class="exit-form-confirmation" *ngIf="data.type === 'exitFormConfirmation'">
      <h1>{{ 'Shared.Atention' | translate }}</h1>
      <p [innerHTML]="'Shared.ExitFormConfirmationInfo' | translate"></p>
      <mat-dialog-actions>
        <div class="buttons deletion-buttons">
          <button mat-button (click)="closeModal()" class="default-button">
            {{ 'Shared.Cancel' | translate }}
          </button>
          <button mat-button (click)="closeAllModals()" class="red-default-button">
            {{ 'Shared.Exit' | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
    <div class="changes-successfully" *ngIf="data.type === 'changesSuccessfully'">
      <h1>{{ data.title || 'Shared.ChangesSuccessfully' | translate }}</h1>
      <div class="changes-successfully-button">
        <button mat-button (click)="closeAllModals(data.closeOnlyCurrentModal)" class="yellow-default-button">
          {{ data.confirmText || 'Shared.BacktoHome' | translate }}
        </button>
      </div>
    </div>
    <div class="deletion-confirmation" *ngIf="data.type === 'deletionConfirmation'">
      <h1>{{ data.title || 'Panel.ConfirmDeleteDevice_title' | translate }}</h1>
      <p [innerHTML]="data.description || 'Panel.ConfirmDeleteDevice_description' | translate"></p>
      <mat-dialog-actions>
        <div class="buttons deletion-buttons">
          <button mat-button (click)="closeModal(false, data.closeOnlyCurrentModal)" class="white-default-button">
            {{ data.cancelText || 'Shared.Cancel' | translate }}
          </button>
          <button mat-button (click)="closeModal(true, data.closeOnlyCurrentModal)" class="red-default-button">
            {{ data.confirmText || 'Panel.ConfirmDeleteDevice_confirmButton' | translate }}
          </button>
        </div>
      </mat-dialog-actions>
    </div>
  </div>
</div>
